import React from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import ProductReportsTab from './ProductReportsTab';

const STORAGE_KEY = 'admin_kundencenter_tab';

type KundencenterSection = 'reports';

const KundencenterTab: React.FC = () => {
  const [section, setSection] = React.useState<KundencenterSection>(() => {
    const saved = (localStorage.getItem(STORAGE_KEY) || 'reports') as KundencenterSection;
    return saved === 'reports' ? saved : 'reports';
  });

  const handleChange = (_: React.SyntheticEvent, value: KundencenterSection) => {
    setSection(value);
    localStorage.setItem(STORAGE_KEY, value);
  };

  return (
    <Box>
      <Paper elevation={0} sx={{ mb: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Tabs value={section} onChange={handleChange} variant="fullWidth" aria-label="Kundencenter" sx={{ width: '100%' }}>
          <Tab label="Reports" value="reports" />
        </Tabs>
      </Paper>

      {section === 'reports' && <ProductReportsTab />}
    </Box>
  );
};

export default KundencenterTab;
